export default "__VITE_ASSET__DhPWKiKn__"